export class PesquisarNoticiaPayload {
  data: Noticia[];
  total: number;
  totalPaginas: number;

  constructor(args) {
    Object.assign(this, args);
  }
}

export class Noticia {
  id: number;
  date: Date;
  title: string;
  description: string;
  subtitle: string;
  link: string;
  linkInterno: boolean;

  author: {
    id: number,
    name: string,
  };

  featuredMedia: {
    canvas: NoticiaMedia,
    thumbnail: NoticiaMedia,
    full: NoticiaMedia,
  };

  public getMedia(): NoticiaMedia {

    if (!this.featuredMedia) {
      return undefined;
    }

    if (this.featuredMedia.canvas) {
      return this.featuredMedia.canvas;
    } else if (this.featuredMedia.full) {
      return this.featuredMedia.full;
    } else if (this.featuredMedia.thumbnail) {
      return this.featuredMedia.thumbnail;
    }
    return undefined;
  }

  constructor(args) {
    Object.assign(this, args);
  }
}

export class NoticiaMedia {
  file: string;
  width: number;
  height: number;
  mime_type: string;
  source_url: string;

  constructor(args) {
    Object.assign(this, args);
  }
}

export class Tag {
  id: number;
  color: string;
  count: number;
  description: string;
  link: string;
  name: string;
  slug: string;
  taxonomy: string;

  constructor(args) {
    Object.assign(this, args);
  }
}
